import { BaseThreeScene } from '@modules/three/common/BaseThreeScene';
import JawCorrection from './JawCorrection';
import JawsCorrection from '@correction/three/JawsCorrection.ts';
import { JawsSegmentationResponse } from '@/schema/jawsSegmentation';

export default class CorrectionService {
  async createJawsCorrection(segmentation: JawsSegmentationResponse): Promise<JawsCorrection> {
    const [upperGum, lowerGum] = await BaseThreeScene.loadGeometries([segmentation.upperJaw.gumModel3dUrl, segmentation.lowerJaw.gumModel3dUrl]);
    const upperTeeth = await BaseThreeScene.loadGeometries([...segmentation.upperJaw.teethSegmentation.map((t) => t.model3dUrl)]);
    const lowerTeeth = await BaseThreeScene.loadGeometries([...segmentation.lowerJaw.teethSegmentation.map((t) => t.model3dUrl)]);
    const upper = new JawCorrection(upperGum, upperTeeth, segmentation.upperJaw, 'upper');
    const lower = new JawCorrection(lowerGum, lowerTeeth, segmentation.lowerJaw, 'lower');
    return new JawsCorrection(lower, upper);
  }
}
